<template>
    <b-input-group>
        <multiselect
                :options="internalOptions"
                :taggable="taggable"
                :multiple="multiple"
                label="name"
                track-by="name"
                v-model="selected"
                @input="onInput"
                selectLabel=""
                :placeholder="placeholder"
                tagPlaceholder=" "
                deselectLabel=""
                :hide-selected="true"
                @tag="addTag"
                :disabled="realDisabled"
        >
            <template #caret="{ toggle }">
                <caret-icon @mousedown.prevent.stop="toggle"></caret-icon>
            </template>
        </multiselect>
        <b-input-group-append v-if="confirmButtons && !disabled" class="transparent">
            <b-btn
                    v-if="realDisabled"
                    @click="realDisabled = false"
            >
                <font-awesome-icon
                        :icon="['far', 'pencil']"
                        size="sm"
                >
                </font-awesome-icon>
            </b-btn>
            <b-btn
                    v-if="!realDisabled && !loading"
                    @click="onConfirm"
            >
                <font-awesome-icon
                        :icon="['fal', 'check']"
                        class="green"
                        size="sm"
                >
                </font-awesome-icon>
            </b-btn>
            <b-btn
                    v-if="!realDisabled && !loading"
                    @click="onCancel"
            >
                <font-awesome-icon
                        :icon="['far', 'times']"
                        class="red"
                        size="sm"
                >
                </font-awesome-icon>
            </b-btn>
            <b-btn
                    v-if="loading"
            >
                <font-awesome-icon
                        :icon="['fal', 'spinner']"
                        size="sm"
                        spin
                >
                </font-awesome-icon>
            </b-btn>
        </b-input-group-append>
    </b-input-group>
</template>

<script>
import Tags from '../../services/Tags/Tags';

export default {
  name: 'Tag-Select',
  inheritAttrs: false,
  props: {
    options: {
    },
    value: {
    },
    confirmButtons: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: 'Select one or more tags',
    },
    taggable: {
      type: Boolean,
      default: true,
    },
    multiple: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      realDisabled: false,
      selected: [],
      originalSelected: [],
    };
  },
  computed: {
    tags() {
      const tags = this.options || this.$store.getters.tags;

      if (tags.length > 0) {
        return Tags.formatDataToMultiSelectObj(tags);
      }
      return [];
    },
    internalOptions() {
      if (this.options) {
        return this.options;
      }

      return this.tags;
    },
  },
  watch: {
    selected: {
      handler(newSelected) {
        if (!this.confirmButtons) {
          this.$emit('input', newSelected);
        }
      },
      immediate: true,
      deep: true,
    },
    disabled(newDisabled) {
      this.realDisabled = newDisabled;
    },
  },
  mounted() {
    if (this.confirmButtons) {
      this.realDisabled = true;
    }

    // set Value to be selected
    this.setSelected(this.value);
    this.originalSelected = this.selected;
  },
  methods: {
    setSelected(newValues = []) {
      const selected = [];

      newValues.forEach((tag) => {
        // Backend now returns active-only tags for options,
        // but an action may have historical/inactive tags assigned.
        // If we can't find the tag in the available options,
        // fall back to the passed-in value so it still displays and isn't accidentally dropped.
        const availableTag = this.tags.find(t => t.name === tag.name);
        const tagToSelect = availableTag || tag;
        selected.push(tagToSelect);
      });

      this.selected = selected;
    },
    getTagNames() {
      return this.value.map(tag => tag.name);
    },
    addTag(tag) {
      const newTag = {
        name: tag,
        code: tag.substring(0, 2) + Math.floor(Math.random() * 10000000),
      };
      this.selected.push(newTag);
    },
    onConfirm() {
      this.originalSelected = this.selected;
      this.$emit('input', this.selected);
      this.$emit('confirm', this.selected);
    },
    onCancel() {
      this.disable();
      this.selected = this.originalSelected;
      this.$emit('cancel', true);
    },
    disable() {
      this.realDisabled = true;
    },
    onInput(value) {
      if (!this.confirmButtons && !this.disabled) {
        this.$emit('input', value);
      }
    },
  },
};
</script>

<style scoped>
</style>
